import {
    withScope,
    captureMessage,
    captureException,
    type SeverityLevel,
} from "@sentry/nextjs";
import { Extras } from "@sentry/core";

interface ReportToSentryParams {
    error: Error | string;

    level?: SeverityLevel;
    extra?: Extras | null;
}

export const reportToSentry = ({
    error,
    level = "fatal",
    extra,
}: ReportToSentryParams) => {
    withScope((scope) => {
        scope.setLevel(level);
        extra && scope.setExtras(extra);

        if (typeof error === "string") {
            captureMessage(error);
        } else {
            captureException(error, scope);
        }
    });
};
